import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ICoreService } from "../coreservicesModal";

export const getAllCoreServices = createAsyncThunk(
  "CoreServices/FindAllCoreServices",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CoreServices/FindAllCoreServices`,
        {
          CoreServicesTitle: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching CoreServices:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createCoreServices = createAsyncThunk(
  "CoreServices/InsertCoreService",
  async (CoreServicesData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CoreServices/InsertCoreService`,
        CoreServicesData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating CoreServices:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateCoreServices = createAsyncThunk(
  "CoreServices/UpdateCoreService",
  async (CoreServicesData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CoreServices/UpdateCoreService`,
        CoreServicesData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating CoreServices:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteCoreServices = createAsyncThunk(
  "CoreServices/DeleteCoreService",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CoreServices/DeleteCoreService`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting CoreServices :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getCoreServicesByID = createAsyncThunk(
  "CoreServices/FindByIDCoreService",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CoreServices/FindByIDCoreService`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        Description: result.Description,
        Image: result.Image,
        URL: result.URL,
        MetaTitle: result.MetaTitle,
        MetaKeywords: result.MetaKeywords,
        MetaDescription: result.MetaDescription,
        IsActive: result.IsActive ? 1 : 2,
      } as ICoreService;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Core Services :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveCoreServices = createAsyncThunk(
  "CoreServices/FindAllActiveCoreServices",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/CoreServices/FindAllActiveCoreServices`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching  Core Services:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveCoreServices = createAsyncThunk(
  "CoreServices/ActiveInActiveCoreService",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CoreServices/ActiveInActiveCoreService`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive  Core Services :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD

export const CoreServicesDetailsImageUpload = createAsyncThunk(
  "CoreServices/CoreServiceImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CoreServices/CoreServiceImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload  Core Services Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
